import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { setCashoutFinal } from 'services/withDraw'
import posthog from 'posthog-js'
import useFinishFlow, { FLOWS } from 'utilities/navigation/flow'

export default function useSEtFinalCashout() {
    const finishFlow = useFinishFlow(FLOWS.cashout)
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IGetCardsPayloadFinal) => {
            return setCashoutFinal(payload)
        },
        onSuccess: (data, variables, payload) => {
            toast.success('برداشت با موفقیت ثبت شد')
            posthog.capture('fund_withdrawal_succeeded', {
                method: 'bank',
                amount: (variables as any)?.amount,
                reason: (variables as any)?.reason,
                moneypool_id: (variables as any)?.moneyPool,
                // what joins the member's درخواست برداشت to the payout that
                // answered it; absent on an ordinary cash-out
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            finishFlow('/funds')
        },
        onError: (error: any, variables) => {
            posthog.capture('fund_withdrawal_failed', {
                method: 'bank',
                status: error?.response?.status,
                withdrawal_request: (variables as any)?.withdrawal_request,
            })
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}
